import { Box, CardMedia, Dialog, Grid, IconButton, Skeleton, Stack, TextField, Typography } from "@mui/material";
import { useWindowSize } from "../../utils/useWindowSize";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { HttpUnAuthApi } from "../../interface/unauth-api";
import { scrapInfoType, userState } from "../../interface/MainInterface";
import dayjs from "dayjs";
import CardBriefDetail from "../brief/CardBriefDetail";
import ToastCustom from "../../utils/ToastCustom";

import "./PopScrapDetail.css";
import { useNavigate } from "react-router-dom";

interface propsType {
  userState: userState;
  callback: any;
}

const unAuthAPI = new HttpUnAuthApi();

const PopScrapDetail2 = (props: propsType, ref: any) => {
  const toastRef: any = useRef();
  const windowSize = useWindowSize();
  const scrapTitleRef: any = useRef();
  const navigate = useNavigate();

  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [editTitle, setEditTitle] = useState(false);
  // const [scrapInfo, setScrapInfo] = useState<scrapInfoType | null>(null);
  const [scrapInfo, setScrapInfo] = useState<any>(null);
  const [briefList, setBriefList] = useState([]);
  const [scrapTitle, setScrapTitle] = useState("");

  useEffect(() => {
    if (scrapInfo) {
      setScrapTitle(scrapInfo.scrap_title);
      setBriefList(scrapInfo.scrap_key_list);
    }
  }, [scrapInfo]);

  const open = (info: any) => {
    if (info) {
      const pk = info.pk;
      const sk = info.sk;
      if (pk !== undefined && sk !== undefined) {
        // console.log(info);
        setScrapInfo(info);
        // get_scrap_info(pk, sk);
      }
    }
    setOpenModal(true);
  };
  
  const close = () => {
    setScrapInfo(null);
    setScrapTitle("");
    setEditTitle(false);
    props.callback({ command: "close" });
    setOpenModal(false);
  };

  const goKeywordGroup = () => {
    navigate(`/group/${scrapInfo.sk}`);
  };

  const get_scrap_info = async (pk: string, sk: string) => {
    const param: any = {
      command: "get_scrap_info",
      pk: pk,
      sk: sk,
      user_id: props.userState.id,
    };
    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
      setScrapInfo(res.response.scrap_info);
      setBriefList(res.response.scrap_info.scrap_key_list);
    }
  };
  
  const update_scrap_title = async () => {
    if (!scrapInfo) return;
    if (scrapInfo?.scrap_title === scrapTitle) {
      setEditTitle(false);
      return;
    }

    const param: any = {
      command: "update_scrap_title",
      pk: scrapInfo.pk,
      sk: scrapInfo.sk,
      new_title: scrapTitle,
      user_id: props.userState.id,
    };
    setIsLoading(true);
    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
      const temp: any = scrapInfo;
      temp.scrap_title = scrapTitle;
      setScrapInfo(temp);
    }
    setEditTitle(false);
    setIsLoading(false);
  };

  // 부모 Component에서 접근 가능하도록 함수 전달.
  useImperativeHandle(ref, () => ({
    open,
  }));

  return (
    <>
      <Dialog
        open={openModal}
        onClose={close}
        PaperProps={{
          style: {
            width: "100%",
            maxWidth: "1000px",
            background: "#ffffff",
            borderRadius: "30px",
          },
        }}
      >
        <Box className="scrap-detail-modal">
          <Box className="header">
            <Box className="title">
              {!editTitle ? (
                <Typography
                  sx={{
                    maxWidth: "calc(100% - 1px)",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    fontSize: windowSize.width > 1023 ? "32px" : "24px",
                    fontWeight: "700",
                    lineHeight: windowSize.width > 1023 ? "41.6px" : "31.2px",
                    cursor: "text",
                  }}
                  onClick={(e) => {
                    e.stopPropagation(); // 부모창 클릭이벤트 전달 방지
                    setEditTitle(true);
                  }}
                >
                  {scrapTitle}
                </Typography>
              ) : (
                <TextField
                  inputRef={scrapTitleRef}
                  className="scrap-title"
                  value={scrapTitle}
                  autoFocus
                  fullWidth
                  onChange={(e) => {
                    setScrapTitle(e.target.value);
                  }}
                  onClick={(e) => {
                    e.stopPropagation(); // 부모창 클릭이벤트 전달 방지
                  }}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      scrapTitleRef.current.blur();
                    }
                  }}
                  onBlur={(e) => {
                    e.preventDefault();
                    update_scrap_title();
                  }}
                  inputProps={{
                    style: {
                      fontSize: windowSize.width > 1023 ? "32px" : "24px",
                      fontWeight: "700",
                      lineHeight: windowSize.width > 1023 ? "41.6px" : "31.2px",
                      padding: 0,
                    },
                    enterKeyHint: "Enter",
                  }}
                ></TextField>
              )}
            </Box>
            <Box className="btn">
              <IconButton
                onClick={() => {
                  close();
                }}
              >
                <CardMedia component={"img"} image="/images/icon-close-m-blk.png" sx={{ height: "22px" }} />
              </IconButton>
            </Box>
          </Box>
          <Box className="timestamp">
            <Typography
              sx={{
                fontSize: windowSize.width > 1023 ? "14px" : "14px",
                fontWeight: "500",
                lineHeight: windowSize.width > 1023 ? "18.2px" : "18.2px",
                color: "#8A8A8A",
              }}
            >{`${dayjs(scrapInfo?.sk).format("YYYY-MM-DD HH:mm")} 생성됨`}</Typography>
          </Box>
          <Box className="content noScrollBar" sx={{ maxHeight: `${windowSize.height - 450}px` }}>
            {isLoading && briefList.length < 1 
              ? [...Array(3)].map((value: any, index: number) => (
                <Box key={`keyword-list-${index}`} sx={{ p: "0px 16px 48px 16px" }}>
                  <Stack direction={"column"} spacing={2}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Stack direction={"row"} spacing={"8px"}>
                        <Skeleton variant="circular" width={"26px"} height={"26px"} />
                        <Box>
                          <Skeleton variant="text" sx={{ width: "200px", fontSize: "16px", fontWeight: "700", lineHeight: "26px" }} />
                        </Box>
                      </Stack>
                    </Box>
                    <Box>
                      <Grid container spacing={"30px"}>
                        {[...Array(3)].map((val: any, index: number) => (
                          <Grid key={`scrap-${index}`} item xs={12} sm={6} md={4} lg={4} xl={4}>
                            <Skeleton
                              variant="rounded"
                              width={"100%"}
                              height={windowSize.width > 1023 ? "153px" : "123px"}
                              sx={{ borderRadius: "30px" }}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                  </Stack>
                </Box>
                ))
                : 
                // <Box sx={{ p: "0px 16px 48px 16px" }}>
                  // <Stack direction={"column"} spacing={2}>
                    <Grid container spacing={"30px"}> 
                      {briefList.map((briefInfo: any, index: number) =>
                        <CardBriefDetail
                          key={`card-brief-detail-${index}`}
                          userState={props.userState}
                          scrapInfo={scrapInfo}
                          briefInfo={briefInfo}
                          callback={(payload: any) => {
                            if (payload.command === "delete_brief") {
                              toastRef.current?.toast("브리프가 삭제되었습니다.", "success", 4000, {
                                vertical: "bottom",
                                horizontal: "center",
                              });
                              if (scrapInfo) get_scrap_info(scrapInfo.pk, scrapInfo.sk);
                            }
                          }}
                        />
                      )}
                    </Grid>
                  // </Stack>
                // </Box>
            }
            {!isLoading && briefList.length < 1 && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "24px",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100px",
                  p: "80px 0px",
                }}
              >
                <Box>
                  <CardMedia component={"img"} image="/images/img-empty.png" sx={{ width: "102px", height: "85px" }} />
                </Box>
                <Box>
                  <Typography sx={{ fontSize: "1rem", fontWeight: "500", lineHeight: "1.3", color: "rgba(138, 138, 138, 1)" }}>
                    {"스크랩 보드가 비어있습니다."}
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
          {/* footer */}
          {props.userState.isAdmin ? (
            <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
              {scrapInfo && (scrapInfo.scrap_status === undefined || scrapInfo.scrap_status === null) && (
                <Box
                  sx={{ width: "100%", display: "flex", justifyContent: "center", p: "24px 16px 32px 16px" }}
                  className={briefList.length === 0 ? "btn-make-monthly-report-ing" : "btn-make-monthly-report"}
                >
                  <button
                    onClick={() => {
                      if (briefList.length === 0) return;
                      // request_make_report();
                      goKeywordGroup();
                    }}
                  >
                    <span>먼슬리 리포트 만들기</span>
                    {briefList.length > 0 && <img src="/images/Union.png" alt="" />}
                  </button>
                </Box>
              )}
              {scrapInfo?.scrap_status === "REQUEST_REPORT" && (
                <Box
                  sx={{ width: "100%", display: "flex", justifyContent: "center", p: "24px 16px 24px 16px" }}
                  className={"btn-make-monthly-report-ing"}
                >
                  <button onClick={() => {}}>
                    <span>리포트 생성중...</span>
                  </button>
                </Box>
              )}
            </Box>
          ) : (
            <Box sx={{ height: "24px" }}></Box>
          )}
        </Box>
      </Dialog>       
      <ToastCustom ref={toastRef} />
    </>
  );
}

export default forwardRef(PopScrapDetail2);